import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import DynamicPage from '../../pages/DynamicPage';
import LoginPage from '../../pages/LoginPage';
import NewsByCategoryPage from '../../pages/NewsByCategoryPage';
import NewsPage from "../../pages/NewsPage";
import PhotoEditPage from '../../pages/PhotoEditPage';
import PhotoGalleryPage from "../../pages/PhotoGalleryPage";
import PostEditPage from "../../pages/PostEditPage";
import PostPage from '../../pages/PostPage';

export default function Middle() {

    const location = useLocation();
    const originalPath = new URLSearchParams(location.search).get('originalPath');

    return (
        <div className="middle">            
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/post/:id" element={<PostPage />} />
                <Route path="/news/:id" element={<NewsByCategoryPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/post/manage/:id" element={<PostEditPage />} />
                <Route path="/post/manage" element={<PostEditPage />} />
                <Route path="/gallery" element={<PhotoGalleryPage />} />
                <Route path="/photo/:id" element={<PhotoEditPage />} />
                <Route index path="*" element={<DynamicPage />} />
            </Routes>
            {originalPath && <Navigate to={originalPath} replace={true} />}
        </div >);
};